import { useMemo } from 'react';

import { AppConfigArea, AppConfigKey, ShopIntegrationType } from 'enums';

import { useAppConfigValue } from './use-app-config-value';

export const useShopIntegrationTypesConfig = () => {
  const { data, isLoading } = useAppConfigValue({
    area: AppConfigArea.Platform,
    key: AppConfigKey.ShopIntegrationTypes,
  });

  const availableShopIntegrationTypes: ShopIntegrationType[] = useMemo(() => {
    const defaultTypes = Object.values(ShopIntegrationType);
    return (data as unknown as ShopIntegrationType[]) || defaultTypes;
  }, [data]);

  const isShopIntegrationAvailable = (type?: ShopIntegrationType) =>
    availableShopIntegrationTypes.includes(type as ShopIntegrationType);

  return {
    availableShopIntegrationTypes,
    isShopIntegrationAvailable,
    isLoading,
  };
};
